<script lang="ts" setup>
// 领取礼包
import { useGlobalData } from '@/utils/useGlobal';

const { showGiftBag } = useGlobalData()
</script>
<template>
  <span class="gift-code-button" @click="showGiftBag = true">
    领取礼包
  </span>
</template>

<style lang="less" scoped>
.gift-code-button {
  display: inline-block;
  text-indent: -9999rem;
  cursor: pointer;
}
.pc{
  .gift-code-button {
    width: 2.48rem;
    height: 1.81rem;
    margin: 0 0 0 -0.36rem;
    background: url("~/images/section1/gift-code-btn.png") no-repeat 0 0 / cover;
    transition: all .1s;
    &:hover{
      filter: brightness(1.1)
    }
  }
}
.wap{
  .gift-code-button {
    width: 1.85rem;
    height: 0.6rem;
    margin-top: 0.04rem;
    background: url("~/images/section1/gift-code-btn-m.png") no-repeat 0 0 / cover;
  }
}

</style>
